import { cloneDeep } from 'lodash';

export function getFieldValueAndLabel(field) {
  let label;
  let val;

  if (field?.review && field?.review?.toReview === false) {
    return { val: null, label: null };
  }

  if (field?.claim_type) { // for customTabs component
    label = field.claim_type === 'Home' ? 'Property' : field.claim_type;
  } else {
    label = field?.review?.label ? field.review.label : null;
  }
  val = field?.review?.defaultValue;

  if (field?.selectedValues && field.selectedValues.length && field.review?.valueKey) { // multiple checkboxes with value as object
    val = [];
    field.selectedValues.forEach((v) => {
      val.push(v[field.review?.valueKey]);
    });
  } else if (field?.selectedValues && field.selectedValues.length && field.review?.typelist) { // multiple checkboxes w/ typelist
    val = [];
    field.selectedValues.forEach((v) => {
      val.push(field.review.typelist[v]);
    });
  } else if (field?.selectedValues && field.selectedValues.length) { // multiple checkboxes no typelist
    val = field.selectedValues;
  } else if (field?.review?.typelist) { // for components with typelists (dropdown, radio buttons, toggle)
    val = field.review.typelist[field.value];
  } else if (field?.review?.value) {
    val = field.review.value;
  } else if (field?.value || field?.value === false) {
    val = field.value;
    if (typeof val === 'boolean') { // checkboxes + toggles
      val = val ? 'Yes' : 'No';
    } else if (field?.review.charLimit && val.length > field.review.charLimit) {
      val = `${val.substring(0, field.review.charLimit)}...`;
    }
  }

  return { val, label };
}

export function addLabelValuePair(fields, label, val, valAsArray) {
  if (label && val) {
    const index = fields.findIndex((l) => l.label === label);
    if (valAsArray && valAsArray.includes(`,${label},`)) {
      if (index >= 0 && !fields[index].val.includes('Unknown')) {
        const newVal = fields[index].val;
        newVal.push(val);
        fields[index].val = newVal;
      } else {
        const newVal = [];
        newVal.push(val);
        fields.push({ label, val: newVal });
      }
    } else if (index >= 0) {
      if (fields[index].val !== 'Unknown') {
        fields[index].val = `${fields[index].val} ${val}`;
      } else {
        fields[index].val = `${val}`;
      }
    } else {
      fields.push({ label, val });
    }
  }
  return fields;
}

export function addFileNames(path, data) {
  let fileNames = [];
  if (path.split('.').length > 1) {
    let newData = data;
    path.split('.').every((key) => {
      if (newData[key]) {
        newData = newData[key];
        if (Object.keys(newData).length === 1 && newData.data) {
          newData = newData.data;
        }
        if (newData?.uploadedDocuments) {
          fileNames = getFileNames(newData);
        }
        return true;
      }
      return false;
    });
  } else if (path !== '') {
    const field = data[path];
    fileNames = getFileNames(field);
  }
  return fileNames;
}

function getFileNames(field) {
  const files = [];
  if (field) {
    field?.uploadedDocuments?.forEach((file) => {
      files.push(file.name);
    });
  }
  return files;
}

export function setPage(instance, currentPage) {
  window.sessionStorage.removeItem('resumeReview');
  const formClaimData = JSON.parse(window.sessionStorage.getItem('updateClaimPayload'));
  instance.setSubmission({ data: cloneDeep(formClaimData?.payload?.submittedData) })
    .then(async () => {
      let pageToSet = -1;
      let pageToGo = [];
      pageToGo.push(currentPage);
      if (pageToGo.length) {
        const newLastVisitesPages = [];
        for (let i = 0; i < instance.pages.length; i += 1) {
          const page = instance.pages[i];
          pageToSet = instance.pages.findIndex((p) => p.path === page.path);
          if (pageToSet < 0) { break; }
          instance.setPage(pageToSet);
          newLastVisitesPages.push(page);
          if (page.path === currentPage) { break; }
        }
        pageToGo = newLastVisitesPages;
      } else if (pageToSet < 1) {
        instance.setPage(1);
        if (formClaimData?.payload?.submittedData?.claim_type?.claim_type === 'Home') {
          pageToGo = ['propertyEmergencyPage'];
        } else {
          pageToGo = ['page1'];
        }
      }
    });
}
